import { Outlet } from 'react-router-dom'

import { EngagementRootPageDocument } from 'generated/resources/graphql'

import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useModuleAvailabilities } from 'modules/core/hooks/useModuleAvailabilities'
import { useQuery } from 'modules/core/hooks/useQuery'

import subscriptionAddons from 'modules/billing/store/collections/subscriptionAddons'
import CollectionsBootstrap from 'modules/engagement/lib/CollectionsBootstrap'
import { EngagementContext } from 'modules/engagement/lib/EngagementContext'
import PageLoading from 'modules/layout/components/Page/Loading'

const Container = () => {
  const { loading: loadingModuleAvailabilities, moduleAvailabilities } = useModuleAvailabilities()
  const { loading: loadingSubcriptions } = useAsyncData(() => subscriptionAddons.fetch(), [])
  const loading = loadingModuleAvailabilities || loadingSubcriptions

  const enpsSubscription = subscriptionAddons.get('enps')
  const enpsInstalled = enpsSubscription?.attributes?.enabled ?? false

  const surveysSubscription = subscriptionAddons.get('surveys')
  const surveysInstalled = surveysSubscription?.attributes?.enabled ?? false
  const { data, loading: loadingFeatures } = useQuery(EngagementRootPageDocument)

  const upsellFlowEnabled = data?.upsell._policies.canRequestUpsell.can ?? false

  const canCreateForms = data?.apiCore._policies.accessSurveysCreateForms.can ?? false
  const canCreateTemplates = data?.apiCore._policies.accessSurveysCreateTemplates.can ?? false
  const canManageSurveys = data?.surveys._policies.v2ManageSurveys.can ?? false
  const canCreateEverybody = data?.surveys._policies.surveyCreateEverybody.can ?? false
  const canCreateReportees = data?.surveys._policies.surveyCreateReportees.can ?? false
  const canCreateTeam = data?.surveys._policies.surveyCreateTeam.can ?? false
  const canCreateOwned = data?.surveys._policies.surveyCreateOwned.can ?? false

  if (loading && !loadingFeatures) {
    return <PageLoading />
  }

  return (
    <EngagementContext.Provider
      value={{
        moduleAvailabilities,
        enpsInstalled,
        enpsSubscription,
        surveysInstalled,
        surveysSubscription,
        upsellFlowEnabled,
        loading,
        canCreateForms,
        canCreateTemplates,
        canManageSurveys,
        canCreateEverybody,
        canCreateReportees,
        canCreateTeam,
        canCreateOwned,
      }}
    >
      <Outlet />
    </EngagementContext.Provider>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
